<template>
  <div>
    <el-card class="box-card">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/goodsInfo' }">商品管理</el-breadcrumb-item>
        <el-breadcrumb-item>编辑商品</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>
    <el-card class="box-card" style="margin-top: 20px;">
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-row>
          <el-col :sm="24" :md="24" :lg="16">
            <el-form-item label="商品名称" prop="name">
              <el-input
                v-model="addForm.name"
                placeholder="请输入商品名称"
                auto-complete="off"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label="商品封面" prop="img">
            <el-input
              type="textarea"
              v-model="addForm.img"
              placeholder="请输入图标"
              auto-complete="off"
              maxlength="300"
            ></el-input>
          </el-form-item>
          </el-col>-->
          <el-col :sm="24" :md="24" :lg="16">
            <el-form-item label="商品封面" prop="img">
              <div class="upload-div">
                <div class="upload-content">
                  <div>
                    <!-- <el-upload
                      class="crm-upload"
                      :action="fileObj.url"
                      :on-remove="handleRemove"
                      :on-change="handleChange"
                      :before-upload="beforeUpload"
                      :on-success="UploadSuccess"
                      :headers="reqData"
                      :on-exceed="handleExceed"
                      multiple
                      :limit="3"
                      list-type="picture"
                      :show-file-list="false"
                    >
                      <div class="content-text">上传封面</div>
                    </el-upload>-->
                  </div>
                  <div class="content-texts">
                    <span class="content-texts">至少上传1张，最多上传3张，每张图片不超过2M,第一张为主图，可拖动图片进行排序</span>
                  </div>
                </div>
              </div>
              <div class="img-list">
                <!-- v-if="addForm.imgs.length" -->
                <div v-if="addForm.imgs.length">
                  <draggable
                    v-model="addForm.imgs"
                    @update="datadragEnd"
                    :options="{animation:500}"
                  >
                    <!-- <transition-group> -->
                    <div class="upload-img" v-for="(item,index) in addForm.imgs" :key="index">
                      <el-image class="upload-img" :src="item" :preview-src-list="addForm.imgs"></el-image>
                      <!-- <el-image class="upload-img" :src="item" :preview-src-list="addForm.imgs"></el-image> -->
                      <div @click="deleteImg(index)" class="delete-img">
                        <i class="el-icon-close icons"></i>
                      </div>
                      <div class="main-img">{{index==0?'主图':'附图'+index}}</div>
                    </div>
                    <!-- </transition-group> -->
                  </draggable>
                </div>
                <div v-if="addForm.imgs.length<3">
                  <el-upload
                    class="crm-upload"
                    :action="fileObj.url"
                    :on-remove="handleRemove"
                    :on-change="handleChange"
                    :before-upload="beforeUpload"
                    :on-success="UploadSuccess"
                    :headers="reqData"
                    :on-exceed="handleExceed"
                    multiple
                    :limit="3"
                    list-type="picture"
                    :show-file-list="false"
                  >
                    <img class="upload-img" :src="defaultImg" alt />
                  </el-upload>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="所属科目" prop="subjectId">
              <!-- <el-input type="number" v-model="searchForm.courseId" auto-complete="off"></el-input> -->
              <el-cascader
                style="width:100%"
                clearable
                v-model="courseIds"
                :empty="addForm.subjectCourseName"
                :show-all-levels="false"
                :props="subjectTreeProps"
                placeholder="请输入所属科目"
                :options="subjectTreeList"
                @change="subjectSearchChange"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="题库课程" prop="questionCourseId">
              <!-- <el-input type="number" v-model="searchForm.courseId" auto-complete="off"></el-input> -->

              <el-select
                :disabled="addForm.subjectId.length?false:true"
                v-model="addForm.questionCourseId"
                filterable
                placeholder="请选择题库课程"
                style="width:100%"
              >
                <el-option
                  v-for="item in questionCourseList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="原价" prop="originalPrice">
              <el-input
                type="number"
                min="0"
                v-model="addForm.originalPrice"
                placeholder="请输入原价(RMB)"
                auto-complete="off"
                @change="originalPriceChange"
                maxlength="10"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="折后价" prop="price">
              <el-input
                type="number"
                min="0"
                v-model="addForm.price"
                placeholder="请输入折后价"
                auto-complete="off"
                maxlength="10"
              >
                <template slot="append">
                  <el-select
                    style="width:90px"
                    v-model="discount"
                    @change="discountChange()"
                    :placeholder="placeholderdiscount"
                  >
                    <el-option
                      v-for="(item,index) in discountOptions"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="有效天数" prop="validDay">
              <el-input
                type="number"
                min="0"
                v-model="addForm.validDay"
                placeholder="请输入有效天数"
                auto-complete="off"
                :disabled="validDayDisabled"
                maxlength="10"
              >
                <template slot="append">
                  <el-checkbox v-model="validDayRadio" label="1" @change="validDayNull()">不限</el-checkbox>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="状态" prop="sell">
              <el-radio v-model="addForm.sell" label="1">上架</el-radio>
              <el-radio v-model="addForm.sell" label="-1">下架</el-radio>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="库存" prop="stock">
              <el-input
                type="number"
                min="0"
                v-model="addForm.stock"
                placeholder="请输入库存"
                auto-complete="off"
                maxlength="10"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="初始销量" prop="sellCount">
              <el-input
                type="number"
                min="0"
                v-model="addForm.sellCount"
                placeholder="请输入销量"
                auto-complete="off"
                maxlength="10"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="24" :lg="16">
            <el-form-item label="课程摘要">
              <el-input
                v-model="addForm.summary"
                placeholder="请输入摘要"
                auto-complete="off"
                maxlength="1000"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="24" :lg="16">
            <el-form-item label="商品介绍" prop="detail">
              <!-- <el-input
              type="textarea"
              v-model="addForm.detailueTtext"
              placeholder="请输入详细介绍"
              auto-complete="off"
              maxlength="65535"
              ></el-input>-->
              <div style="background: #FFF" v-if="showUe">
                <UE name="1" :value="ueTtext" ref="myQuillEditorTitle"></UE>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div>
        <el-button @click="addFormBack">重置</el-button>
        <el-button type="primary" @click="addGoodsInfo">提交</el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import UE from "../conmom/CKEditor.vue";
import draggable from "vuedraggable";
export default {
  components: { UE, draggable },
  data() {
    return {
      postDisabled: false,
      showUe: true,
      offTimeDisabled: false,
      validDayDisabled: false,
      placeholderdiscount: "不打折",

      defaultImg: "../../../static/image/defaultImg2.png",
      fileObj: {
        url: process.env.BASE_URL + "/system/uploadFile"
      },
      ueTtext: "",
      subjectTreeList: [], //科目
      questionCourseList: [], //科目
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      addTeacherList: [],
      offTimeRadio: null,
      validDayRadio: null,

      addForm: {
        name: "",
        imgs: [],
        img: "",
        subjectId: "",
        questionCourseId: "",
        originalPrice: "",
        price: "",
        validDay: "",
        material: "",
        sell: "1",
        stock: "",
        sellCount: "",
        onTime: "",
        offTime: "",
        summary: "",
        detail: ""
      },
      formLabelWidth: "80px",
      addFormRules: {
        name: [
          {
            required: true,
            message: "请输入商品名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 20,
            message: "商品名称长度在1到100个字"
          }
        ],
        img: {
          required: true,
          message: "请选择商品图片",
          trigger: "change"
        },
        onTime: {
          required: true,
          message: "请选择上架时间",
          trigger: "change"
        },
        // img: [
        //   {
        //     required: true,
        //     message: "请输入图标",
        //     trigger: "blur"
        //   },
        //   {
        //     min: 1,
        //     max: 300,
        //     message: "图标长度在1到300个字"
        //   }
        // ],

        validDay: [
          {
            required: true,
            message: "请输入有效天数",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "有效天数格式不正确"
          }
        ],
        tags: [
          {
            required: true,
            message: "请输入标签",
            trigger: "blur"
          },
          {
            min: 1,
            max: 1000,
            message: "标签长度在1到1000个字"
          }
        ],
        subjectId: [
          {
            required: true,
            message: "请选择所属科目",
            trigger: "change"
          }
        ],
        postpone: [
          {
            required: true,
            message: "请输入是否支持延期",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "是否支持延期格式不正确"
          }
        ],
        sellCount: [
          {
            required: true,
            message: "请输入初始销量",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "初始销量格式不正确"
          }
        ],
        price: [
          {
            required: true,
            message: "请输入折后价",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "折后价格式不正确"
          }
        ],
        originalPrice: [
          {
            required: true,
            message: "请输入原价",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "原价格式不正确"
          }
        ],
        summary: [
          {
            required: true,
            message: "请输入摘要",
            trigger: "blur"
          },
          {
            min: 1,
            max: 1000,
            message: "摘要长度在1到1000个字"
          }
        ],
        detail: [
          {
            required: true,
            message: "请输入详细介绍",
            trigger: "blur"
          },
          {
            min: 1,
            max: 65535,
            message: "详细介绍长度在1到65535个字"
          }
        ]
      },
      discountOptions: [
        {
          value: "1",
          label: "不打折"
        },
        {
          value: "0.9",
          label: "9折"
        },
        {
          value: "0.8",
          label: "8折"
        },

        {
          value: "0.7",
          label: "7折"
        },
        {
          value: "0.6",
          label: "6折"
        },
        {
          value: "0.5",
          label: "5折"
        },
        {
          value: "0.4",
          label: "4折"
        },
        {
          value: "0.3",
          label: "3折"
        },
        {
          value: "0.2",
          label: "2折"
        },
        {
          value: "0.1",
          label: "1折"
        }
      ],
      subjectTreeList: [], //科目
      courseIds: [], //科目
      discount: "",
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children"
      }
    };
  },
  watch: {
    "addForm.price": function(newVal) {
      if (Number(this.addForm.originalPrice) > 0) {
        this.placeholderdiscount =
          (
            Number(this.addForm.price) / Number(this.addForm.originalPrice)
          ).toFixed(2) *
            10 ==
          10
            ? "不打折"
            : (
                Number(this.addForm.price) / Number(this.addForm.originalPrice)
              ).toFixed(2) *
                10 +
              "折";
        if (Number(this.addForm.price) > Number(this.addForm.originalPrice)) {
          this.$message.error("输入错误，折后价不能大于原价！！！");
          // this.addForm.price = "";
        }
      }
    }
  },
  methods: {
    originalPriceChange() {
      this.addForm.price = this.addForm.originalPrice;
      this.discountChange();
    },
    offTimeNull() {
      if (this.offTimeRadio == 1) {
        this.offTimeDisabled = true;
        this.addForm.offTime = null;
      } else {
        this.offTimeDisabled = false;
      }
    },
    validDayNull() {
      if (this.validDayRadio == 1) {
        this.validDayDisabled = true;
        this.addForm.validDay = null;
        this.addFormRules.validDay = [
          {
            required: false,
            message: "请输入有效天数",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "有效天数格式不正确"
          }
        ];
      } else {
        this.validDayDisabled = false;
        this.addFormRules.validDay = [
          {
            required: true,
            message: "请输入有效天数",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "有效天数格式不正确"
          }
        ];
      }
    },
    discountChange() {
      this.checked = false;
      this.addForm.price = parseInt(
        (this.discount ? this.discount : 1) * this.addForm.originalPrice
      );
    },
    subjectSearchChange() {
      console.log(this.courseIds);
      if (this.courseIds) {
        this.addForm.subjectId = this.courseIds[1];
        this.getSubjectCourseListByPid(this.courseIds[1]);
      } else {
        this.searchForm.subjectId = "";
        this.questionCourseList = [];
        this.addForm.questionCourseId = "";
      }
    },
    deleteImg(index) {
      this.addForm.imgs.splice(index, 1);
      this.$set(this.addForm, "imgs", this.addForm.imgs);
      console.log(this.addForm.imgs);
      this.$forceUpdate();
    },
    datadragEnd(evt) {
      console.log(1111, this.addForm.imgs);
      this.$forceUpdate();
      evt.preventDefault();
    },
    getSubjectTreeList() {
      // 获取课程
      this.api
        .getSubjectTreeList()
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                delete items.children;
                // if (items.children.length != 0) {
                //   for (let itemss of items.children) {
                //     delete itemss.children;
                //   }
                // } else {
                //   // delete items.children;
                // }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
          this.getGoodsInfo();
        })
        .catch(error => {
          console.log(error);
        });
    },
    UploadSuccess(res, file, fileList, val) {
      this.addForm.imgs.push(res.data);
      this.$set(this.addForm, "imgs", this.addForm.imgs);

      this.$forceUpdate();
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `商品图片最多可选择3张，本次选择了 ${
          files.length
        } 个图片，共选择了 ${files.length + fileList.length} 个图片`
      );
    },
    handleRemove(file, fileList) {},
    handleChange(file, fileList) {},
    beforeUpload(file) {
      if (this.addForm.imgs.length == 3) {
        return this.$message.error("商品图片最多上传三张");
      }
      const isJPG = file.type.indexOf("image") > -1;
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传文件必须是图片哦!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    addFormBack() {
      this.addForm.name = "";
      this.addForm.img = "";
      this.addForm.sell = 1;
      this.addForm.imgs = [];

      this.addForm.subjectId = "";
      this.addForm.originalPrice = "";
      this.addForm.price = "";
      this.addForm.validDay = "365";

      this.addForm.material = "";
      this.addForm.stock = "";
      this.addForm.sellCount = "";
      this.addForm.onTime = "";
      this.addForm.offTime = "";
      this.addForm.summary = "";
      this.addForm.detail = "";
      //this.$router.push({ path: "/goodsInfo" });
    },
    addGoodsInfo() {
      console.log(this.addForm.imgs);
      if (this.$refs.myQuillEditorTitle._data.content) {
        this.addForm.detail = this.$refs.myQuillEditorTitle._data.content;
        this.addForm.img = this.addForm.imgs.toString();
        this.$refs.addForm.validate(valid => {
          if (valid) {
            if (
              Number(this.addForm.price) > Number(this.addForm.originalPrice)
            ) {
              return this.$message.error("输入错误，折后价不能大于原价！！！");
              // this.addForm.price = "";
            }
            this.api.goodsInfo
              .updateGoodsInfo(this.addForm)
              .then(result => {
                if (result.success) {
                  this.$message({
                    type: "success",
                    message: result.message
                  });
                  // this.$router.push(
                  //   {
                  //     path: "/goodsInfo/goodsItem",
                  //     query: {updatePageGoodsItem: this.$route.query.updatePageId
                  //   }},
                  // );
                  this.$router.push({ path: "/goodsInfo" });
                } else {
                  this.$message.error(result.message);
                }
              })
              .catch(error => {
                console.log(error);
              });
          } else {
            // this.addForm.imgs = this.addForm.img
            //   ? this.addForm.img.split(",")
            //   : [];
            return false;
          }
        });
      } else {
        this.$message.error("商品介绍不能为空");
      }
    },
    getSubjectCourseListByPid(id) {
      this.api.subjectCourse
        .getSubjectCourseListByPid({ pid: id })
        .then(result => {
          this.questionCourseList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getGoodsInfo() {
      this.showUe = false;
      this.api.goodsInfo
        .getGoodsInfo({
          id: this.$route.query.updatePageId
        })
        .then(result => {
          this.getSubjectCourseListByPid(result.data.subjectId);
          this.addForm = result.data;
          if (result.data.img) {
            this.addForm.imgs = result.data.img.split(",");
          } else {
            this.addForm.imgs = [];
          }
          // this.courseIds = ["1197773608737206274", "1198096732914819074"];
          if (this.addForm.offTime == null) {
            this.offTimeRadio = true;
            this.offTimeDisabled = true;
          } else {
            this.offTimeRadio = null;
            this.offTimeDisabled = false;
          }
          if (this.addForm.validDay == null) {
            this.validDayRadio = true;
            this.validDayDisabled = true;
            this.addFormRules.validDay = [
              {
                required: false,
                message: "请输入有效天数",
                trigger: "blur"
              },
              {
                pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
                message: "有效天数格式不正确"
              }
            ];
          } else {
            this.validDayRadio = null;
            this.validDayDisabled = false;
            this.addFormRules.validDay = [
              {
                required: true,
                message: "请输入有效天数",
                trigger: "blur"
              },
              {
                pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
                message: "有效天数格式不正确"
              }
            ];
          }
          console.log("subjectTreeList", this.subjectTreeList);
          this.subjectTreeList.forEach(element => {
            if (element.children) {
              element.children.forEach(elements => {
                if (elements.id == result.data.subjectId) {
                  this.courseIds = [element.id, elements.id];
                  // this.courseIds.push(element.id);
                  // this.courseIds.push(elements.id);
                }
              });
            }
          });
          console.log(123, this.courseIds);

          this.ueTtext = this.addForm.detail;
          this.addForm.sell = String(this.addForm.sell);
          this.showUe = true;
          this.placeholderdiscount =
            (this.addForm.price / this.addForm.originalPrice).toFixed(2) * 10 +
            "折";
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    }
  },
  mounted() {
    this.getSubjectTreeList();
  }
};
</script>
<style lang="less" scoped>
.list-name-img {
  display: flex;
  flex-direction: row;
  align-items: center;
  img {
    width: 40px;
    height: 40px;
    border-radius: 4px;
    margin-right: 10px;
  }
}

.img-list {
  display: flex;
  margin-top: 10px;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  .select {
    opacity: 0.6;
    background: #333;
  }
  .main-img {
    margin: 0 10px;
    text-align: center;
    font-size: 14px;
    margin-top: -20px;
    width: 160px;
    height: 40px;
    line-height: 40px;
  }
  .upload-img {
    display: inline-block;
    width: 160px;
    height: 100px;
    border-radius: 4px;
    margin: 0 10px;
    position: relative;
    cursor: pointer;
    padding: 0px;
  }
  .delete-img {
    top: -5px;
    right: -10px;
    // width: 160px;
    // height: 100px;
    border-radius: 4px;
    position: absolute;
    z-index: 12;
    cursor: pointer;
    .icons {
      color: #fff;
      background-color: #333;
      border-radius: 50%;
      font-weight: bolder;
      z-index: 1343;
      font-size: 20px;
    }
  }
}
.upload-div {
  display: flex;
  flex-direction: row;

  .upload-content {
    // margin-left: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .content-text {
      width: 80px;
      height: 32px;
      border-radius: 4px;
      border: 1px solid rgb(77, 148, 255);
      color: rgb(77, 148, 255);
      font-size: 12px;
      line-height: 32px;
    }
    .content-texts {
      color: rgb(162, 170, 188);
      font-size: 12px;
      white-space: nowrap;
      // margin-left: 5px;
    }
  }
}
.el-radio + .el-radio {
  margin-left: 0px !important;
}
.margin-left {
  margin: 0px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/goods/editGoodsTiku.vue